import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import { translate } from '@/services/TranslationService';
import { getIconForReport } from '../myCity/MyCityHelper';
import MapBoxContainer from '../myCity/MyCityMapContainer';
import { withNOVOHeader } from '../sideMenu/HeaderHOC';
import { ReportItem } from './ReportItem';
import { getSingleReport } from './actions';

const ReportDetails = (props) => {
  const [markerHtmlArray, setMarkerHtmlArray] = useState([]);
  const dispatch = useDispatch();
  const reports = useSelector((state) => state.reportsReducer.myReports);
  const fetchedReport = useSelector(
    (state) => state.reportsReducer.activeReport
  );
  const reportsLoading = useSelector((state) => state.reportsReducer.loading);
  const { setHeaderTitle } = props;
  const { location } = props;
  const data = location.pathname.split('/');
  const reportId = data[2];

  const fetchedReportMatchesRoute =
    fetchedReport?.id?.toString() === reportId?.toString();
  const report =
    (fetchedReportMatchesRoute && fetchedReport) ||
    reports.find((report) => report.id.toString() === reportId?.toString());

  useEffect(() => {
    setHeaderTitle(translate('sideMenu.MyReports'));
  }, []);

  useEffect(() => {
    if (reportId) {
      dispatch(getSingleReport(reportId));
    }
  }, [dispatch, reportId]);

  useEffect(() => {
    if (report) {
      const imageElement = new Image(40, 40);
      imageElement.src = '../' + getIconForReport(report.status_name);
      setMarkerHtmlArray([`${report.status_name}`, imageElement]);
    }
  }, [report]);

  if (!report) {
    return <div>{reportsLoading ? 'Loading...' : 'Report not found'}</div>;
  }

  return (
    <ReportItem
      key={report.id}
      report={report}
      showDescription={true}
      showHistory={true}
      map={
        <MapBoxContainer
          zoom={[14]}
          center={[parseFloat(report.longitude), parseFloat(report.latitude)]}
          selectedPoint={{
            latitude: report.latitude,
            longitude: report.longitude,
          }}
          markerHtmlArray={markerHtmlArray}
          onClick={() =>
            window.open(
              `https://www.google.com/maps/@${parseFloat(report.latitude)},${parseFloat(report.longitude)}/?q=${parseFloat(report.latitude)},${parseFloat(report.longitude)}`,
              '_blank'
            )
          }
        />
      }
    />
  );
};

export default withNOVOHeader(withRouter(ReportDetails));
